'use client';

import { useEffect, useState } from 'react';

export const useBrowserLanguage = () => {
  const [language, setLanguage] = useState('en-GB');

  useEffect(() => {
    setLanguage(window.navigator.language);
  }, []);

  return language;
};
